export default __webpack_public_path__ + "static/media/continue button.de954c25.png";